import { Redirect, Stack } from 'expo-router';
import { ActivityIndicator, View } from 'react-native';
import { useAuth } from '../../src/context/AuthContext';
import { AppHeader } from '../../src/components/AppHeader';
import { colors } from '../../src/theme';

export default function AppLayout() {
  const { isLoading, token } = useAuth();

  if (isLoading) {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: colors.background }}>
        <ActivityIndicator size="large" color={colors.primary} />
      </View>
    );
  }

  if (!token) {
    return <Redirect href="/(auth)/login" />;
  }

  return (
    <Stack
      screenOptions={{
        header: ({ navigation, route, options, back }) => (
          <AppHeader
            title={options.title ?? route.name}
            canGoBack={!!back}
            onBack={() => navigation.goBack()}
          />
        ),
        contentStyle: { backgroundColor: colors.background },
      }}
    >
      <Stack.Screen name="(tabs)" options={{ headerShown: false }} />
      <Stack.Screen name="create-shop" options={{ title: 'Tạo shop mới' }} />
      <Stack.Screen name="create-task" options={{ title: 'Tạo nhiệm vụ' }} />
      <Stack.Screen name="shop/[id]" options={{ title: 'Chi tiết shop' }} />
      <Stack.Screen name="task/[id]" options={{ title: 'Chi tiết nhiệm vụ' }} />
      <Stack.Screen name="submission/[id]" options={{ title: 'Nhiệm vụ đang thực hiện' }} />
      <Stack.Screen name="admin-withdrawals" options={{ title: 'Duyệt rút tiền' }} />
      <Stack.Screen name="admin-topups" options={{ title: 'Duyệt nạp tiền' }} />
      <Stack.Screen name="admin-duplicate-devices" options={{ title: 'Thiết bị trùng' }} />
      <Stack.Screen name="admin-duplicate-photos" options={{ title: 'Ảnh trùng lặp' }} />
      <Stack.Screen name="admin-identity-verifications" options={{ title: 'Duyệt xác minh danh tính' }} />
      <Stack.Screen name="admin-users" options={{ title: 'Quản lý người dùng' }} />
      <Stack.Screen name="admin-user-detail/[id]" options={{ title: 'Chi tiết người dùng' }} />
    </Stack>
  );
}
